import { get } from '@alltrails/core/utils/get';

export async function getNlSuggestions() {
  return get<any>(`/api/alltrails/explore/v1/query_suggestions`, { params: { limit: 6 } });
}
